export default __webpack_public_path__ + "static/media/music.cd670b2b.jpg";